import "core-js/modules/es.array.unscopables.flat.js";
import { useCallback as e, useEffect as n, useState as t, useMemo as r, useRef as o } from "react";
import { raf as c } from "@studio-freight/tempus";
import { throttle as u } from "throttle-debounce";
function i(t, r) {
  const o = e(e => {
    t.current && !t.current.contains(e.target) && r();
  }, [t, r]);
  n(() => {
    if (t.current) return document.addEventListener("mousedown", o), () => {
      document.removeEventListener("mousedown", o);
    };
  }, [o, t]);
}
function s() {
  const [e, r] = t(!1);
  return n(() => {
    r(!0);
  }, []), e;
}
function a() {
  const e = s();
  return r(() => e && (window.location.href.includes("#debug") || "development" === process.env.NODE_ENV) && !window.location.href.includes("#production"), [e]);
}
function d() {
  const [e, r] = t(() => "undefined" != typeof document ? document.readyState : "loading");
  return n(() => {
    if ("undefined" != typeof document) return r(document.readyState), document.addEventListener("readystatechange", e, !1), () => document.removeEventListener("readystatechange", e, !1);
    function e() {
      r(document.readyState);
    }
  }, []), e;
}
function f(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  n(() => {
    if (e) return c.add(e, t), () => c.remove(e);
  }, [e, t]);
}
function v(e, t) {
  const r = o(),
    c = o();
  return n(() => {
    r.current = e;
  }), n(() => {
    if (null !== t) return c.current = setInterval(function () {
      r.current();
    }, t), () => clearInterval(c.current);
  }, [t]), () => clearInterval(c.current);
}
function l() {
  const r = e(() => "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0, []),
    [o, c] = t(void 0),
    u = e(() => {
      c(r());
    }, [r]);
  return n(() => (u(), window.addEventListener("resize", u, {
    passive: !0
  }), () => {
    window.removeEventListener("resize", u, {
      passive: !0
    });
  }), [u]), o;
}
function m() {
  let {
    root: r = null,
    rootMargin: c = "0px",
    threshold: u = 1,
    once: i = !1
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const s = o(),
    a = o(),
    [d, f] = t(!1),
    v = e(e => {
      a.current || (a.current = e);
    }, []),
    l = e(e => {
      const [n] = e;
      f(n.isIntersecting);
    }, []);
  return n(() => (a.current && (s.current = new IntersectionObserver(l, {
    root: r,
    rootMargin: c,
    threshold: u
  }), s.current.observe(a.current)), () => {
    s.current && s.current.disconnect();
  }), [l]), n(() => {
    i && d && s.current.disconnect();
  }, [d]), {
    setRef: v,
    inView: d
  };
}
function p(o) {
  const c = s(),
    u = r(() => {
      if (c) try {
        return window.matchMedia(o);
      } catch (e) {
        "production" !== process.env.NODE_ENV && console.error(e);
      }
      return null;
    }, [o, c]),
    [i, a] = t(void 0),
    d = e(_ref => {
      let {
        matches: e
      } = _ref;
      a(e);
    }, []);
  return n(() => {
    if (u) return d(u), u.addEventListener("change", d, {
      passive: !0
    }), () => {
      u.removeEventListener("change", d, {
        passive: !0
      });
    };
  }, [u, d, c]), i;
}
function h() {
  return h = Object.assign ? Object.assign.bind() : function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, h.apply(this, arguments);
}
function w(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const t = n + e.offsetTop;
  return e.offsetParent ? w(e.offsetParent, t) : t;
}
function g(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const t = n + e.offsetLeft;
  return e.offsetParent ? g(e.offsetParent, t) : t;
}
function y() {
  let {
    lazy: r = !1,
    debounce: c = 1e3
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const i = o(),
    s = o(),
    [a, d] = t({}),
    f = o(a),
    v = e(() => {
      if (i.current) {
        const e = w(i.current),
          n = g(i.current);
        f.current = h({}, f.current, {
          top: e,
          left: n
        }), r || d(f.current);
      }
    }, [r]);
  n(() => {
    const e = u(c, v),
      n = new ResizeObserver(e);
    return n.observe(document.body), () => {
      n.disconnect(), e.cancel({
        upcomingOnly: !0
      });
    };
  }, [c, v]);
  const l = e(_ref2 => {
      let [e] = _ref2;
      const {
        width: n,
        height: t
      } = e.contentRect;
      f.current = h({}, f.current, {
        width: n,
        height: t
      }), r || d(f.current);
    }, [r]),
    m = e(() => f.current, []);
  return n(() => () => {
    var e;
    "development" !== process.env.NODE_ENV && (null == (e = s.current) || e.disconnect());
  }, []), [e(e => {
    var n;
    e && e !== i.current && (null == (n = s.current) || n.disconnect(), s.current = new ResizeObserver(l), s.current.observe(e), i.current = e);
  }, [v]), r ? m : a];
}
function b() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const t = r(() => n && [n].flat(), [n]),
    o = r(() => e && [e].flat(), [e]);
  return r(() => {
    if (!t || !o) return;
    const n = o.map(e => {
      var n;
      return null == (n = t.find(n => n.type === e)) ? void 0 : n.props.children;
    });
    return e[0] ? n : n[0];
  }, [t, o]);
}
export { a as useDebug, d as useDocumentReadyState, f as useFrame, v as useInterval, s as useIsClient, l as useIsTouchDevice, m as useIsVisible, p as useMediaQuery, i as useOutsideClickEvent, y as useRect, b as useSlots };